export default "__VITE_ASSET__BMtGHyAT__"